__webpack_require__.p = "/wave-collapse/";